import { CSSResultGroup, html, LitElement, nothing } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'
import { rmaError } from './error.style.js'

const translations = {
  title: () => t('title', { ns: 'csc-rma-error', default: 'Something went wrong' }),
  text: () => t('text', { ns: 'csc-rma-error', default: 'An error occurred while processing your return request.' }),
  error: () => t('error', { ns: 'csc-rma-error', default: 'Error' }),
  back: () => t('back', { ns: 'csc-rma-error', default: 'Back to overview' }),
}

@customElement('csc-rma-error')
export class CSCRmaError extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, rmaError]

  @property({ attribute: 'back-url', type: String })
  public backUrl = ''

  @property({ attribute: 'status', type: String })
  public status = ''

  @property({ attribute: 'status-text', type: String })
  public statusText = ''

  private renderDetail() {
    if (!this.status) {
      return nothing
    }
    const suffix = this.statusText ? ` : ${this.statusText}` : ''
    return html`
      <p class="rma-error__detail" role="alert" data-test="rma-error-detail">
        ${translations.error()} ${this.status}${suffix}
      </p>
    `
  }

  override render() {
    return html`
      <div class="rma-error" data-test="rma-error">
        <cse-text variant="heading-1" data-test="rma-error-title">${translations.title()}</cse-text>
        <cse-text variant="body-m">${translations.text()}</cse-text>
        ${this.renderDetail()}
        ${this.backUrl
          ? html`
              <cse-button variant="primary" url=${this.backUrl} data-test="rma-error-back">
                <cse-icon slot="prefix" icon-name="house" icon-style="light"></cse-icon>
                ${translations.back()}
              </cse-button>
            `
          : nothing}
      </div>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-rma-error': CSCRmaError
  }
}
